export default __webpack_public_path__ + "static/media/00FF00.685bef7e.svg";